import React from "react";
export default function CloseIcon() {
  return (
    <svg viewBox="0 0 20 20" width={20} height={20}>
      <path
        fillRule="evenodd"
        d="m11.414 10 4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a1 1 0 0 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"
      />
    </svg>
  );
}
